import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from 'ui';
import { withRouter } from 'utils/withRouter';
import Sticky from '../../common/sticky/sticky';

const Container = styled(Flex)`
  background-color: rgb(245, 248, 250) !important;
  height: 55px;
  font-size: 16px !important;
  margin: 0 -20px;
  padding-left: 20px;
  text-transform: uppercase;
`;

const Item = styled.div`
  height: 3rem;
  height: 100%;
  font-weight: ${p => p.theme.fontWeight.bolder};
  cursor: pointer;
  align-items: center;
  display: flex;
  p {
    color: ${p => p.theme.colors.text};
    padding: 10px 15px;
    border-bottom: 3px solid transparent;
    &:hover {
      color: ${p => p.theme.colors.theme};
    }
  }
  ${p => p.isActive && `
    p {
      color: ${p.theme.colors.theme} !important;
      padding-top: 13px;
    }
    border-bottom: 3px solid ${p.theme.colors.theme};
  `}
`;


const TypesMenu = ({ menuVisible, items, match, history }) =>
  <Sticky
    menuVisible={menuVisible}
    translateYEnd='-160px'
    extraStyles={{ 'z-index': '7 !important' }}
  >
    <Container ffrn jcfs aic>
      {items?.map((i, index) =>
        <Item
          key={index}
          isActive={match.params.type === i.type}
          onClick={() => history.push(history.location.pathname.replace(match.params.type, i.type))}
        >
          <p>{i.title}</p>
        </Item>,
      )}
    </Container>
  </Sticky>;
TypesMenu.propTypes = {
  items: PropTypes.array,
  match: PropTypes.object,
  history: PropTypes.object,
  menuVisible: PropTypes.bool,
};

export default withRouter(TypesMenu);
